import React, { useState, useContext, useEffect, useRef } from 'react';
import Context from "../context/context";
import classnames from 'classnames';

const FilterSearch = props => {
  const {setMobileMenu, setTopMobileMenu, activeFilters, setActiveFilters, filterNav, setFilterNav, setNavStatus} = useContext(Context);
  const {data, open, multi, handleClose, clearAllFilters, widget, single} = props;
  const elements = data.elements;
  let checked = [];

  const firstInputRef = useRef(null);

  useEffect(() => {

    if (open && firstInputRef.current) {

      firstInputRef.current.focus();
    }
  }, [open]);

  let searchValue = activeFilters.search.value;

  const updateSearch = (val) => {
    searchValue = val;
    const search = {...activeFilters.search};
    search.value = val;
    setActiveFilters({...activeFilters,
      search
    });
    // let container = document.querySelector('.filter-grid'),
    //       template = document.querySelector('.template'),
    //       template_height = template.offsetHeight,
    //       header = document.querySelector('.header'),
    //       header_height = header.offsetHeight,
    //       pos = container.offsetTop;
    // window.scrollTo(0, template_height + pos - header_height)

  }



 






  return (
    <fieldset >
    <div className="form-row-container">
    <div className="form-row">

      <div className="form-element form-element-text search full">
        <label htmlFor={data.name}>Search</label>
        <input
        type="search"
        name={data.name}
        placeholder={data.title}
        value={searchValue}
        onChange={(e) => updateSearch(e.target.value)}
    />
        <div class="search-all-results" ></div>
      </div>
    </div>

  </div>
  </fieldset>


  )
}

export default FilterSearch;
